import snackBarUpdate from "../../actions/snackBarActions";
import Prefix from "../../config/ApiPrefix";
import AXIOS from "../../config/Axios";
import SecureStorage from "../../config/SecureStorage";
import { ACTIONS } from "../interfaces/actionTypes/GenomicsResearchinterface";
// import { AnyLengthString } from "aws-sdk/clients/comprehend";

export const handleError = (dispatch: any, err: any) => {
  let title = "";
  if (err.response) {
    title = err.response.data.error;
    if (err.response.data.message) {
      title = String(err.response.data?.message).replace(/"|{|}|[|]/g, "");
    }
  } else {
    title = "Something went wrong!";
  }
  snackBarUpdate({
    payload: {
      message: title || "Something went wrong",
      status: true,
      type: "error",
    },
  })(dispatch);
  dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  throw err;
};
export const getAuthHeader = () => {
  const token = SecureStorage.getItem("token");
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

export const changePassword = (body: any) => async (
  dispatch: Function
) => {
  try {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    await AXIOS.post(`${Prefix.api}/auth/password_reset/reset_password/`,
      body,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      });
    dispatch({ type: ACTIONS.CHANGE_PASSWORD, payload: null });
    snackBarUpdate({
      payload: {
        message: "Password Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
  } catch (err: any) {
    let title = "";
    if (err.response) {
      title = String(err.response.data?.errors?.error);
    } else {
      title = "Something went wrong!";
    }
    snackBarUpdate({
      payload: {
        message: title || "Something went wrong",
        status: true,
        type: "error",
      },
    })(dispatch);
    dispatch({ type: ACTIONS.SET_LOADING, payload: false });
    throw err;
  }
};

export const getCities = (search: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/core/cities/${search ? `?q=${search}` : ""}`,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_CITIES, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const getUserDetails = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(`${Prefix.sso}/auth/shortprofile/`, {
      headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
    });
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: data });
  } catch (err: any) {
    dispatch({ type: ACTIONS.GET_USER_DETAILS, payload: [] });
    handleError(dispatch, err);
  }
};

export const getBookingOverview = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/stats/${url ? `?${url}` : ""}`,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_BOOKING_OVERVIEW, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const createClient = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/scientists/ `,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_CLIENT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Client/Scientist Created",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const getClient = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/scientists/${url ? `?${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_CLIENT, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateClient = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/scientists/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_CLIENT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Client Details Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createDealer = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/dealers/ `,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_DEALER, payload: data });
    snackBarUpdate({
      payload: {
        message: "Dealer Created",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateDealer = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/dealers/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_DEALER, payload: data });
    snackBarUpdate({
      payload: {
        message: "Dealer Details Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getDealer = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/dealers/${url ? `?${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_DEALER, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createInstitute = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/institutes/ `,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_INSTITUE, payload: data });
    snackBarUpdate({
      payload: {
        message: "Client Created",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateInstitute = (bookingData: any, id: any, url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/institutes/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_INSTITUTE, payload: data });
    snackBarUpdate({
      payload: {
        message: "Institute Details Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getInstitute = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/institutes/${url ? `?${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_INSTITUTE, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getSampleAccessioning = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/samples/${url ? `?${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_SAMPLE_ACCESSIONING, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateSamplesAccessioning = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/samples/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_SAMPLES_ACCESSIONING, payload: data });
    snackBarUpdate({
      payload: {
        message: "Sample Details Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const createSampleAcessioning = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/samples/ `,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_SAMPLE_ACESSIONING, payload: data });
    snackBarUpdate({
      payload: {
        message: "Samples Created",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createProject = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/projects/ `,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_PROJECT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Project Created",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateProject = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/projects/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_PROJECT, payload: data });
    snackBarUpdate({
      payload: {
        message: "Project Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjects = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/projects/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_PROJECTS, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getApplications = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/applications/?limit=1000${url ? `&${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_APPLICATIONS, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};

export const uploadMediaFiles = (bookingData: any) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/media/`,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.UPLOAD_MEDIA_FILES, payload: data });
    snackBarUpdate({
      payload: {
        message: "Upload Sucessfully",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getSampleAccessioningFilter = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/samples/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_SAMPLE_ACCESSIONING_FILTER, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjectsFiletr = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/projects/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_PROJECTS_FILTER, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const createFailedSampleNames = (bookingData: any, id: any,) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/failed-samples/${id}/`,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_FAILED_SAMPLES_NAMES, payload: data });
    snackBarUpdate({
      payload: {
        message: "Create Sucessfully",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getFailedSample = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/failed-samples/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_FAILED_SAMPLES, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjectSamples = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/project-samples/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_PROJECT_SAMPLES, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getProjectSampleAllData =
  (id: any) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/project-samples/${id ? id : ""}`,

        getAuthHeader()
      );
      dispatch({ type: ACTIONS.GET_PROJECTS_SAMPLE_ALL_DATA, payload: data });
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
export const getTicket = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/ticket/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    console.log("data", data);
    dispatch({ type: ACTIONS.GET_TICKETS, payload: data });
  } catch (err: any) {
    console.log("error", err);
    handleError(dispatch, err);
  }
};
export const createTicket = (bookingData: any, id: any,) => async (dispatch: Function) => {
  try {
    const { data } = await AXIOS.post(
      `${Prefix.api1}/genomics/ticket`,
      bookingData,
      {
        headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
      }
    );
    dispatch({ type: ACTIONS.CREATE_TICKET, payload: data });
    snackBarUpdate({
      payload: {
        message: "Create Sucessfully",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const updateTicket = (bookingData: any, id: any) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.put(
      `${Prefix.api1}/genomics/ticket/${id}/`,
      bookingData,
      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.UPDATE_TICKET, payload: data });
    snackBarUpdate({
      payload: {
        message: "Project Updated",
        status: true,
        type: "success",
      },
    })(dispatch);
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const getLoginUser = (url: string) => async (dispatch: Function) => {
  dispatch({ type: ACTIONS.SET_LOADING, payload: true });
  try {
    const { data } = await AXIOS.get(
      `${Prefix.api1}/genomics/user/${url ? `${url}` : ""} `,

      { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
    );
    dispatch({ type: ACTIONS.GET_LOGIN_USER, payload: data });
  } catch (err: any) {
    handleError(dispatch, err);
  }
};
export const UpdateStatusClosed =
  (bookingData: any, id: any, url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/ticket/${id}/close-Status`,
        bookingData,
        getAuthHeader()
      );
      dispatch({ type: ACTIONS.UPDATE_STATUS_CLOSED, payload: data });
      snackBarUpdate({
        payload: {
          message: "Ticket Sucessfully Closed",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
  export const getComments = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/ticket-comment/${url ? `${url}` : ""} `,
  
        { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
      );
      console.log("data", data);
      dispatch({ type: ACTIONS.GET_COMMENTS, payload: data });
    } catch (err: any) {
      console.log("error", err);
      handleError(dispatch, err);
    }
  };
  export const updateComments = (bookingData: any, id: any,) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/ticket-comment/`,
        bookingData,
        {
          headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        }
      );
      dispatch({ type: ACTIONS.UPDATE_COMMENTS, payload: data });
      snackBarUpdate({
        payload: {
          message: "Reply Sucessfully Done",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
  export const getStatusByYear = (url: string) => async (dispatch: Function) => {
    dispatch({ type: ACTIONS.SET_LOADING, payload: true });
    try {
      const { data } = await AXIOS.get(
        `${Prefix.api1}/genomics/projects/stats_by_year `,
  
        { headers: { Authorization: `Token ${SecureStorage.getItem("token")}` } }
      );
      console.log("data", data);
      dispatch({ type: ACTIONS.GET_STATUS_BY_YEAR, payload: data });
    } catch (err: any) {
      console.log("error", err);
      handleError(dispatch, err);
    }
  };
  export const sendFileShare = (bookingData: any, id: any,) => async (dispatch: Function) => {
    try {
      const { data } = await AXIOS.post(
        `${Prefix.api1}/genomics/projects/share_file`,
        bookingData,
        {
          headers: { Authorization: `Token ${SecureStorage.getItem("token")}` },
        }
      );
      dispatch({ type: ACTIONS.SEND_FILE_SHARE, payload: data });
      snackBarUpdate({
        payload: {
          message: "file Sucessfully Sended",
          status: true,
          type: "success",
        },
      })(dispatch);
    } catch (err: any) {
      handleError(dispatch, err);
    }
  };
